import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import RegularButton from 'components/CustomButtons/Button'
import { useForm } from 'hooks/useForm'
import React, { memo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { FormCustomerTypeRuleEdit } from './FormCustomerTypeRuleEdit'
import AddIcon from "@mui/icons-material/Add";
import { generateRandomID } from 'helpers/generateRandomID'
import { FormSeasonRuleEdit } from './FormSeasonRuleEdit'
import { FormCustomerNameRuleEdit } from './FormCustomerNameRuleEdit'

export const FormContractRuleEdit = memo((props) => {
  const { setNewRules, setRulesKeys, setRules, rules, rule, rulesKeys } = props.ruleHandlers
  const { rulesArr, deleteMode } = useSelector(state => state.contractsCatalog)
  const [selectedRuleKeys, setSelectedRuleKeys] = useState([])
  const [rulesOptionsFiltered, setRulesOptionsFiltered] = useState(rulesArr)
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({ id: '' })
  const { id } = inputValues

  useEffect(() => {
    if (rule?.noteKey) {
      if(rule.type === 'CUSTOMER_TYPE') {
        const customerTypes = rulesKeys.filter(ruleKey => ruleKey.idRule === rule.id)
        if(customerTypes.length) {
          setSelectedRuleKeys(customerTypes.map(type => ({...type, itemId: generateRandomID(32)})))
        } else setSelectedRuleKeys([{idRule: rule.id, idRuleKey: generateRandomID(32), itemId: generateRandomID(32)}])
      }
      handleNewValues({
        id: rule.id,
      })
    }
    //eslint-disable-next-line 
  }, [rule?.id])
  
  useEffect(() => {
    if(id) {
      if(id !== rule?.id) {
        const newRule = rulesArr.filter(rule => rule.id === id)[0]
        if(newRule?.type === 'NORMAL') {
          setRulesKeys([...rulesKeys.filter(ruleKey => ruleKey.idRule !== newRule.id), ...newRule.ruleKeys.map(ruleKey => ({idRule: newRule.id, idRuleKey: ruleKey.id}))])
          setRules(rules.map(item => {
            if (item.itemId === rule.itemId) {
              return {
                ...item,
                ...newRule,
                isComplete: 'good'
              }
            }
            else return item
          }))
        } else {
          setRules(rules.map(item => {
            if (item.itemId === rule.itemId) {
              return {
                ...item,
                ...newRule,
                isComplete: 'bad'
              }
            }
            else return item
          }))
        }
      }
    }
  }, [handleInputOnChange])

  useEffect(() => {
    if(rules.length > 1) {
      if(rules.length === rulesArr.length) setNewRules(false)
      else setNewRules(true)
      const rulesSelected = rules.filter(item => item.id !== rule.id).map(rule => rule.id)
      setRulesOptionsFiltered(rulesArr.filter(option => !rulesSelected.includes(option.id)))
    }
  }, [rules])

  return (
    <>
      <FormControl fullWidth style={{ display: 'flex', gap: 10, marginTop: 20, alignItems: 'center' }}>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Regla *</InputLabel>
          <Select
            name="id"
            value={id}
            onChange={e => handleInputOnChange(e)}
            label="Regla *"
            disabled={deleteMode}
          > 
            { rulesOptionsFiltered.map(item => <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>) }
          </Select>
        </FormControl>
        {
          rule?.type === 'CUSTOMER_TYPE' && 
            <>
              <Box style={{display: 'flex', justifyContent: 'space-between', marginTop: 30, width: '98%'}}>
                <Typography style={{ alignSelf: 'center' }}>Agregar Nuevo Tipo de Cliente</Typography>
                <RegularButton 
                  disabled={selectedRuleKeys.length === rule.ruleKeys.length} 
                  round 
                  justIcon 
                  color="info" 
                  style={{ margin: 10 }} 
                  onClick={() => setSelectedRuleKeys([...selectedRuleKeys, {idRule: rule.id, idRuleKey: generateRandomID(32), itemId: generateRandomID(32)}])}
                >
                  <AddIcon style={{ margin: 0 }}/>
                </RegularButton>
              </Box>
              {
                selectedRuleKeys.map(ruleKey => (<FormCustomerTypeRuleEdit
                  key={ruleKey.itemId} 
                  ruleHandlers={props.ruleHandlers} 
                  setSelectedRuleKeys={setSelectedRuleKeys} 
                  selectedRuleKeys={selectedRuleKeys}
                  ruleKey={ruleKey}
                />))
              }
            </>
        }
        {
          rule?.type === 'SEASON' ? <FormSeasonRuleEdit ruleHandlers={props.ruleHandlers}/> 
            : rule?.type === 'CUSTOMER' && <FormCustomerNameRuleEdit ruleHandlers={props.ruleHandlers}/>  
        }
      </FormControl>
    </>
  )
})
